import LearningSection from 'LearningManager/components/LearningSection';
import { learningPaths } from 'LearningManager/constants/createAssignment.constant';
import { useStepper } from 'LearningManager/hooks/Stepper.context';
import styles from 'LearningManager/styles/QuickSetup.module.scss';

const LearningPath: React.FC = () => {
	const {
		draft: {
			quickSetup: { selectedLearningPathCourseIds }
		},
		toggleQuickCourseSelection
	} = useStepper();

	return (
		<div className={styles.learningPath}>
			<div className={styles.learningPath__heading}>
				Learning Path Review
			</div>
			<div className={styles.learningPath__desc__container}>
				<div className={styles.learningPath__desc}>
					Quick setup automatically assigns learning paths based on
					employee roles.
				</div>
				<div className={styles.learningPath__desc}>
					Venza offers comprehensive awareness training through three
					curated learning paths: Basic, Intermediate, and Advanced.
					Each curriculum consists of a series of individual courses
					that are carefully designed to provide a standard-setting
					training experience.
				</div>
				<div className={styles.learningPath__desc}>
					Staff receive the Basic Learning Path, Managers receive the
					Basic and Intermediate Paths, and Leadership + IT receive
					all three paths.
				</div>
			</div>

			<div className={styles.learningPath__wrapper}>
				{learningPaths.map((section, sectionIndex) => (
					<LearningSection
						key={section.title}
						{...section}
						courses={section.courses.map((course) => {
							const uniqueCourseId =
								sectionIndex * 100 + course.id;
							return {
								...course,
								id: uniqueCourseId,
								isSelected: selectedLearningPathCourseIds.includes(
									uniqueCourseId
								)
							};
						})}
						onSelectCourse={toggleQuickCourseSelection}
					/>
				))}
			</div>
		</div>
	);
};

export default LearningPath;
